import { formatMontant } from '@mairistem/finances-utils';
import React from 'react';

const renderMontantText = (montant: number, isBold = false) => (
	<span className={['montantText', ...(isBold ? ['bold'] : [])].join(' ')}>
		{formatMontant(montant ?? 0)}
	</span>
);

export default renderMontantText;
